<template>
    <div class="datetime-picker" v-show="visible" @click="hide()">
        <div class="datetime-picker_container" ref="datetimePicker" @click.stop>
            <div class="picker-header">
                <div class="picker-header_title">
                    <slot name="title">{{textConfig.title}}</slot>
                </div>
                <div class="picker-header_confirm">
                    <slot name="title"><span class="confirm-text" @click="confirm()">确认</span></slot>
                </div>
            </div>
            <div class="picker-range_tabbar" v-if="range">
                <ul>
                    <li :class="{'active': activeType == 0}" @click="switchRange(0)">{{startDateStr}}</li>
                    <li :class="{'active': activeType == 1}" @click="switchRange(1)">{{endDateStr}}</li>
                </ul>
            </div>
            <div class="picker-content">
                <div class="picker-column" 
                    v-for="key,index in columns" :key="key" 
                    @scroll="columnScroll(key)" 
                    @touchstart="columnTouchstart()" 
                    @touchend="columnTouchend(key)" 
                    :ref="key"
                    :class="key"
                >
                    <ul class="picker-column_box">
                        <li class="picker-column_item" v-for="item,itemIndex in columnsList[key]" :key="itemIndex">{{item}}{{textConfig.column[key] || ''}}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import tools from '@/common/tools';
const typeConfig = {
    'datetime': {
        t: '日期时间',
        f: 'yyyy-MM-dd HH:mm'
    },
    'datetime-all': {
        t: '日期时间',
        f: 'yyyy-MM-dd HH:mm:ss'
    },
    'date': {
        t: '日期',
        f: 'yyyy-MM-dd'
    },
    'date-year': {
        t: '年份',
        f: 'yyyy'
    },
    'date-month': {
        t: '年月',
        f: 'yyyy-MM'
    },
    'time': {
        t: '时间',
        f: 'HH:mm:ss'
    }
}
export default {
    name: 'DatetimePicker',
    props: {
        type: {
            type: String,
            default: 'datetime',
            validator: t=>t in typeConfig
        },
        value: {
            type: [String, Array]
        },
        min: {
            type: String,
            default: ''
        },
        max: {
            type: String,
            default: ''
        },
        title: String,
        range: Boolean
    },
    data(){
        return {
            visible: false,
            values: null,
            minDate: null,
            maxDate: null,
            columnsList: {},
            scrollEndTimer: null,
            isTouchend: true,
            isSetScroll: false,
            activeType: 0,
            rangeValues: [],
        }
    },
    computed:{
        typeConfig(){
            return typeConfig[this.type];
        },
        textConfig(){
            let config = {};
            if(this.title){
                config.title = this.title;
            }else{
                config.title = this.typeConfig.t;
            }
            config.column = {
                year: '年',
                month: '月',
                day: '日',
                hour: '时',
                minute: '分',
                second: '秒'
            }
            return config;
        },
        
        columns(){
            const o = {
                "y+": 'year',
                "M+": 'month',
                "d+": 'day',
                "H+": 'hour',
                "m+": 'minute',
                "s+": 'second'
            };
            let columns = [];
            let format = this.typeConfig.f;
            for (let k in o){
                let info = format.match(new RegExp(`(${k})`));
                if(info){
                    columns[info.index] = o[k];
                }
            }
            return columns.filter(c=>c);
        },
        columnItemHeight(){
            return tools.remToPx(56);
        },
        startDateStr(){
            if(!this.range) return '';
            let [start] = this.rangeValues;
            return this.stringifyDatetime(start) || `开始${this.typeConfig.t}`;
        },
        endDateStr(){
            if(!this.range) return '';
            let [,end] = this.rangeValues;
            return this.stringifyDatetime(end) || `结束${this.typeConfig.t}`;
        }
    },
    methods: {
        //显示
        show(){
            this.visible = true;
            this.$refs.datetimePicker.classList.add('enter');
            setTimeout(()=>{
                this.$refs.datetimePicker.classList.remove('enter');
            }, 400)
            this.$nextTick(function(){
                let value, min, max;
                if(this.range){
                    let [start, end] = this.value || [];
                    this.activeType = 0;
                    value = start;
                    min = this.min;
                    max = end ? end : this.max;
                    this.rangeValues = [this.parseDatetime(this.getDate(start)), this.parseDatetime(this.getDate(end))];
                }else{
                    value = this.value || '';
                    min = this.min;
                    max = this.max;
                }
                this.init({
                    value,
                    min,
                    max
                });
            })
        },
        //隐藏
        hide(){
            this.$refs.datetimePicker.classList.add('leave');
            setTimeout(()=>{
                this.visible = false;
                this.$refs.datetimePicker.classList.remove('leave');
            }, 400)
        },
        //补0
        replenish(number){
            return (number < 10 ? '0' : '') + number;
        },
        //获取 date
        getDate(valueStr){
            let date;
            if(valueStr){
                switch(this.type){
                    case 'time':
                        date = new Date(`1900-01-01 ${valueStr}`);
                        break;
                    case 'date-year':
                        date = new Date(`${valueStr}-01-01 `);
                        break;
                    case 'date-month':
                        date = new Date(`${valueStr}-01 `);
                        break;
                    default:
                        date = new Date(valueStr);
                        break;
                }
            }
            if(date == 'Invalid Date') return ;
            return date;
        },
        //parse 格式
        parseDatetime(date){
            date = typeof date == 'string' ? new Date(date) : date;
            if(!date || date == 'Invalid Date') return;
            let year = date.getFullYear(),
                month = date.getMonth() + 1,
                day = date.getDate(),
                hour = date.getHours(),
                minute = date.getMinutes(),
                second = date.getSeconds();
            return {year, month, day, hour, minute, second};
        },
        //stringify 格式
        stringifyDatetime(value){
            if(!value) return;
            let {year, month, day, hour, minute, second} = value;
            let format = this.typeConfig.f;
            var o = {
                "y+": year,
                "M+": month,
                "d+": day,
                "H+": hour,
                "m+": minute,
                "s+": second
            };
            for (var k in o)
                if (new RegExp(`(${k})`).test(format))
                    format = format.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (this.replenish(o[k])));
            return format;
        },
        //范围选择切换 
        switchRange(type){
            if(this.activeType != type){
                this.activeType = type;
                let [start, end] = this.rangeValues;
                let value, min, max;
                if(type == 0){
                    value = this.stringifyDatetime(start);
                    min = this.min;
                    max = end ? this.stringifyDatetime(end) : this.max;
                }else{
                    value = this.stringifyDatetime(end);
                    min = start ? this.stringifyDatetime(start) : this.min;
                    max = this.max;
                }
                this.init({
                    value,
                    min,
                    max
                })
            }
        },
        //初始化
        init({value, min, max}){
            let date = this.getDate(value) || new Date();
            let minDate = this.getDate(min),
                maxDate = this.getDate(max);
            if(minDate && minDate > date){
                date = minDate;
            }
            if(maxDate && maxDate < date){
                date = maxDate;
            }
            this.values = this.parseDatetime(date);
            this.minDate = this.parseDatetime(min);
            this.maxDate = this.parseDatetime(max);
            this.updateColumns();
        },
        //确认
        confirm(){
            let format, values;
            if(this.range){
                let [start, end] = this.rangeValues;
                format = [this.stringifyDatetime(start), this.stringifyDatetime(end)];
                values = [start, end];
            }else{
                format = this.stringifyDatetime(this.values);
                values = this.values;
            }
            this.$emit('change', format, values);
            this.hide();
        },
        //更新选项
        updateColumns(columnKey){
            const keys = ['year', 'month', 'day', 'hour', "minute", 'second'];
            const columns = this.columns;
            let values = this.values;
            let newValues = {...values};
            let newLists = {...this.columnsList};
            this.isSetScroll = true;
            let updateColumnKeys = keys.filter(key=>columns.includes(key));
            let startIndex = updateColumnKeys.findIndex(key=>key == columnKey),
                endIndex = updateColumnKeys.length;
            if(startIndex == -1) startIndex = 0;
            for(let i=startIndex;i<endIndex;i++){
                let key = updateColumnKeys[i];
                let {
                    min,
                    max,
                    list
                } = this.getColumns(key, newValues);
                let value = values[key];
                if(value < min || value > max){
                    newValues[key] = min;
                }else{
                    newValues[key] = value;
                }
                newLists[key] = list;
            }

            this.$set(this, 'columnsList', newLists);
            this.values = {...newValues};
            if(this.range){
                this.$set(this.rangeValues, this.activeType, {...this.values});
            }
            this.$nextTick(function(){
                let height = this.columnItemHeight;
                for(let i=startIndex;i<endIndex;i++){
                    let key = updateColumnKeys[i];
                    let columnDom = this.$refs[key][0];
                    if(columnDom){
                        let list = newLists[key];
                        let value = newValues[key];
                        let itemIndex = list.findIndex(item=>item == value);
                        columnDom.scrollTop = itemIndex * height;
                    }
                }
            })
        },
        //获取每列选项
        getColumns(type, values = {}){
            let list = [];
            let min = 0, max = 0;
            switch (type){
                case 'year':
                    min = 1900, max = 2099;
                    break;
                case 'month':
                    min = 1, max = 12;
                    break;
                case 'day':
                    let {year, month} = values;
                    min = 1, max = this.getLastDay(year, month);
                    break;
                case 'hour':
                    min = 0, max = 23;
                    break;
                case 'minute':
                case 'second':
                    min = 0, max = 59;
                    break;
            }
            const keys = ['year', 'month', 'day', 'hour', "minute", 'second'];
            const columns = this.columns;
            let updateColumnKeys = keys.filter(key=>columns.includes(key));
            let minDate = this.minDate,
                maxDate = this.maxDate;
            let isStart = true,
                isEnd = true;
            for(let i=0;i<updateColumnKeys.length;i++){
                let key = updateColumnKeys[i];
                if(key == type){
                    if(i == 0){
                        if(!minDate) isStart = false;
                        if(!maxDate) isEnd = false;
                    }
                    break;
                }else{
                    let value = values[key];
                    if(isStart && (!minDate || value != minDate[key])){
                        isStart = false;
                    }
                    if(isEnd && (!maxDate || value != maxDate[key])){
                        isEnd = false;
                    }
                }
            }
            if(isStart) min = minDate[type];
            if(isEnd) max = maxDate[type];
            for(let i=min;i<=max;i++){
                list.push(i);
            }
            return {
                min,
                max,
                list
            };
        },
        //获得某月的最后一天
	  	getLastDay(year,month) {        
			 let new_year = year;     
			 let new_month = month++;      
			 if(month>12) {        
                new_month -=12;     
                new_year++;  
			 }        
			 let new_date = new Date(new_year,new_month,1);      
			 return (new Date(new_date.getTime()-1000*60*60*24)).getDate();     
		},
        //处理滚动列的选项位置
        setColumnScroll(key){
            let columnDom = this.$refs[key][0];
            let scrollTop = columnDom.scrollTop;
            let height = this.columnItemHeight;
            let itemIndex = parseInt(scrollTop / height);
            if(scrollTop % height > (height / 2)){
                itemIndex++;
            }
            columnDom.scrollTop = itemIndex * height;
            let columnsList = this.columnsList;
            let value = +columnsList[key][itemIndex];
            if(value != this.values[key]){
                this.values[key] = value;
                this.updateColumns(key);
            }
        },
        //触摸 滚动
        columnScroll(key){
            if(!this.isTouchend || this.isSetScroll) {
                this.isSetScroll = false;
                return;
            }
            clearTimeout(this.scrollEndTimer);
            this.scrollEndTimer = setTimeout(()=>{
                this.setColumnScroll(key);
            }, 100)
        },
        columnTouchstart(){
            this.isTouchend = false;
            this.isSetScroll = false;
        },
        columnTouchend(key){
            this.isTouchend = true;
            clearTimeout(this.scrollEndTimer);
            this.scrollEndTimer = setTimeout(()=>{
                this.setColumnScroll(key);
            }, 100)
        }
    }
}
</script>
<style lang="scss" scoped>
.datetime-picker{
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.6);
    z-index: 1200;
    .datetime-picker_container{
        max-width: 750px;
        width: 100%;
        height: auto;
        padding-bottom: var(--safe-area-inset-bottom);
        background: #ffffff;
        border-radius: 24px 24px 0 0;
        position: absolute;
        left: 0;
        bottom: 0;
        &.enter{
            transform: translateY(0%);
            animation: enter .3s linear;
        }
        &.leave{
            transform: translateY(100%);
            animation: leave .3s linear;
        }
        .picker-header{
            width: 100%;
            height: 72px;
            padding: 0 32px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .picker-header_title{
                font-size: 32px;
                color: #1B1C1E;
                font-weight: 500;
            }
            .picker-header_confirm{
                .confirm-text{
                    font-size: 28px;
                    color: #7AD21A;
                }
            }
        }
        .picker-range_tabbar{
            width: 100%;
            margin: 24px 0;
            ul{
                display: flex;
                align-items: center;
                justify-content: space-around;
                li{
                    width: 295px;
                    height: 64px;
                    background: #f5f5f5;
                    border-radius: 10px;

                    font-size: 32px;
                    color: #1B1C1E;
                    font-weight: 500;
                    line-height: 64px;
                    text-align: center;
                    &.active{
                        color: #7AD21A;
                    }
                }
            }
        }
        .picker-content{
            --itemNumber: 7;
            --height: calc(56px * var(--itemNumber));
            width: 100%;
            height: calc(var(--height) + 64px);
            padding: 32px;
            box-sizing: border-box;
            position: relative;

            display: flex;
            align-items: center;
            justify-content: space-around;
            &::before{
                content: '';
                width: 100%;
                height: 56px;
                background-color: #f3f3f3;
                border: 1px solid #dfdfdf;
                border-left: none;
                border-right: none;
                box-sizing: border-box;
                position: absolute;
                left: 0;
                top: calc(50% - 28px);
                pointer-events: none;
            }
            &::after{
                content: '';
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                pointer-events: none;
                background: linear-gradient(180deg,rgba(255,255,255,.95) 0%, rgba(255,255,255,.5) calc(50% - 28px), rgba(255,255,255,0) calc(50% - 28px),rgba(255,255,255,0) calc(50% + 28px), rgba(255,255,255,.5) calc(50% + 28px), rgba(255,255,255,.95) 100%);
            }
            .picker-column{
                height: 100%;
                width: 90px;
                overflow-x: hidden;
                overflow-y: auto;
                position: relative;
                &.year{
                    width: 140px;
                }
                .picker-column_box{
                    width: 100%;
                    height: auto;
                    padding: calc(56px * ((var(--itemNumber) - 1) / 2)) 0;
                    box-sizing: border-box;
                    .picker-column_item{
                        width: 100%;
                        height: 56px;
                        font-size: 32px;
                        color: #1B1C1E;
                        font-weight: 500;
                        line-height: 56px;
                        text-align: center;
                    }
                }
            }
        }
    }
}
@keyframes enter{
    from{
        transform: translateY(100%);
    }
    to{
        transform: translateY(0%);
    }
}
@keyframes leave{
    from{
        transform: translateY(0%);
    }
    to{
        transform: translateY(100%);
    }
}
</style>